import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import SvgIcon from 'vue-svgicon';
import App from './App.vue';
import './components/icons';

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);

Vue.use(SvgIcon, {
    tagName: 'svg-icon'
});

new Vue({
	render: h => h(App),
}).$mount('#app')